module.exports = __webpack_public_path__ + "img/shipin1.c60cab06.jpg";